import { batchRedux } from '@helpers';

import { fetchCalendar } from '../../api/calendar';
import {
	SET_CALENDAR,
	SET_CURRENT_CALENDAR,
	SET_ORDER_STATUS_CALENDAR,
	UPDATE_CURRENT_CALENDAR,
	RESET_CALENDAR,
} from './actionTypes';
import { getMenuCartAction } from '../menu/actions';

export const getCalendarAction = () => (dispatch) => {
	fetchCalendar().then((res) => {
		dispatch({
			type: SET_CALENDAR,
			payload: res,
		});
	});
};

export const setCurrentCalendarAction = (data) => (dispatch) => {
	const dayId = data.id;

	batchRedux(() => {
		dispatch({
			type: SET_CURRENT_CALENDAR,
			payload: data,
		});

		dispatch(getMenuCartAction(dayId));
	});
};

export const updateCurrentCalendarAction = (isEndOrderTime, delivered) => (
	dispatch,
	getState,
) => {
	const current = getState().calendar.current;

	const payload = {};
	if (current.isEndOrderTime !== isEndOrderTime) {
		payload.isEndOrderTime = isEndOrderTime;
	}
	if (current.delivered !== delivered) {
		payload.delivered = delivered;
	}

	if (Object.keys(payload).length) {
		dispatch({
			type: UPDATE_CURRENT_CALENDAR,
			payload,
		});
	}
};

export const setOrderStatusCalendarAction = (dayId, hasOrder = true) => (
	dispatch,
	getState,
) => {
	const list = getState().calendar.list;

	const newList = [];
	list.forEach((item) => {
		if (item.id === dayId) {
			newList.push({ ...item, hasOrder });
		} else {
			newList.push(item);
		}
	});

	dispatch({
		type: SET_ORDER_STATUS_CALENDAR,
		payload: {
			list: newList,
			current: { hasOrder },
		},
	});
};

export const resetCalendarAction = () => ({
	type: RESET_CALENDAR,
	payload: true,
});
